document.addEventListener("DOMContentLoaded", function () {
  const tabLinks = document.querySelectorAll(".tablink");
  const tabContent = document.querySelectorAll(".tabcontent");

  if (tabLinks !== null) {
    tabLinks.forEach(function (el) {
      el.addEventListener("click", openTabs);
    });
  }

  function openTabs(el) {
    const btnTarget = el.currentTarget;
    const tabId = btnTarget.dataset.tab;

    tabLinks.forEach(function (el) {
      el.parentElement.classList.remove("js-active");
    });

    tabContent.forEach(function (el) {
      el.classList.remove("js-active");

      if (el.id == tabId) {
        el.classList.add("js-active");
      }
    });

    btnTarget.parentElement.classList.add("js-active");
  }
});
